// token 授权
const authorization = token => 'Bearer ' + token

// 获取 token
const token = authorization => authorization.substr(7)

// rem 设置
const rem = (unit = 10, maxWidth = 768) => {
  document.documentElement.style.fontSize = (unit * Math.min(window.innerWidth, maxWidth) / 375) + 'px'
}

// rem => px
const toRem = (px) => {
  return parseFloat(px) / parseFloat(document.documentElement.style.fontSize)
}

// px => rem
const toPx = (rem) => {
  return parseFloat(document.documentElement.style.fontSize) * parseFloat(rem)
}

// 跳转外部地址
const toLink = (url, target = '_blank') => {
  url && window.open(url, target)
}

// 新地址
const newUrl = () => {
  const url = new URL(window.location.href)

  // 移除指定的查询参数
  url.searchParams.delete('code')
  url.searchParams.delete('state')
  url.searchParams.delete('mp_token')
  url.searchParams.delete('token')

  return url.toString()
}

// 范围内随机
const rand = (min, max) => Math.random() * (max - min) + min


// 判断是否是模板进入
const isInTemplate = () => {
  return !!localStorage.getItem('is_template')
}
// 判断是否微信端
const isWechat = () => {
  const userAgent = navigator.userAgent
  return /MicroMessenger/i.test(userAgent) && /Mobile|Android|iPhone/i.test(userAgent)
}

// 判断是否合法ID
const isId = input => input && (new RegExp('^[1-9][0-9]*$', 'i')).test(input)

// H5页面工具方法
const isInMiniProgram = () => {
  // 通过wx对象存在性检测（更可靠）
  try {
    if (navigator.userAgent.indexOf("miniProgram") > -1 ||
      window.__wxjs_environment === "miniprogram") {
        return true;
      }
  } catch (e) {
    return false;
  }

  // 通过postMessage能力检测（最准确）
  return typeof uni !== 'undefined' || typeof plus !== 'undefined';
};

export { authorization, token, rem, toRem, toPx, rand, isId, toLink, isWechat, newUrl, isInMiniProgram, isInTemplate }

